<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import { t } from "@/controllerLK/AvalLocalization";

const emit = defineEmits(["close", "save-changes", "toggleItem"]);
const props = defineProps({
  title: {
    type: String,
    required: true,
    default: () => "title"
  },
  items: {
    type: Array,
    required: true
  },
  selectedItems: {
    type: Array,
    required: true,
    default: () => []
  }
});

onMounted(() => {
  if (props.selectedItems) {
    selectedItemsCopy.value = [...props.selectedItems];
  }
});

const isFormSubmitted = ref(false);
const selectedItemsCopy = ref([]);
const searchInputValue = ref("");

const toggleItem = (item) => {
  const existingItem = selectedItemsCopy.value.find((selectedItem) => selectedItem === item);
  if (existingItem) {
    selectedItemsCopy.value.splice(selectedItemsCopy.value.indexOf(item), 1);
  } else {
    selectedItemsCopy.value.push(item);
  }
};

// Список элементов
const getItems = computed(() => {
  if (searchInputValue.value.length > 0) {
    return props.items
        .filter((filteredItem) => filteredItem.name.toLowerCase().includes(searchInputValue.value.toLowerCase()));
  } else {
    return props.items;
  }
});

const handleFormSubmit = () => {
  isFormSubmitted.value = true;
  emit("save-changes", selectedItemsCopy);
};
</script>

<template>
  <AvalSidebar
    :title="props.title"
    :use-cross-icon="true"
    :use-cancel="false"
    :is-confirm-pressed="isFormSubmitted"
    :confirm-text="t('news_page_popup_sidebar.button')"
    teleport="#app"
    @close="emit('close')"
    @confirm="handleFormSubmit"
  >
    <div class="sidebar-body">
      <div class="sidebar-body__search">
        <AvalInputSearchSecondary
          v-model="searchInputValue"
          :placeholder="t('news_page_popup_sidebar.placeholder.search')"
        />
      </div>
      <AvalListView class="sidebar-body__list">
        <AvalListItem
          v-for="item in getItems"
          :key="item"
          v-model="selectedItemsCopy"
          :item="item.id"
          :use-checkbox="true"
        >
          {{ item.name }}
        </AvalListItem>
      </AvalListView>
      <div class="sidebar-body__selected scroll">
        <div class="hr-line" />
        <div
          v-for="item in selectedItemsCopy"
          :key="item"
        >
          <AvalChip
            :label="props.items.find((filteredItem) => String(filteredItem.id) === String(item))?.name"
            :use-cross-icon="true"
            @cancel="toggleItem(item)"
          />
        </div>
      </div>
    </div>
  </AvalSidebar>
</template>

<style scoped lang="scss">

.hr-line {
  height: 1px;
  width: 100%;
  background: #EEF1FF;
  margin-bottom: 3px;
}

.sidebar {
  position: fixed;
  z-index: 2000;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 100%;
  padding: 14px;
  background: var(--background-bg-white);
  box-shadow: 1px 2px 10px 0 #131E2726;
  gap: 10px;

  &-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: calc(100% - 87px);

    &__selected {
      display: flex;
      flex-wrap: wrap;
      max-height: 250px;
      gap: 5px;
      height: auto;
      min-height: 40px;
      overflow-y: auto;
      padding-right: 10px;
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;
      padding-right: 10px;
    }
  }
}
</style>